"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTheMethodVideo = exports.TheMethodVideoWatchedEntrySchemaList = exports.TheMethodVideoWatchedEntrySchema = exports.TheMethodVideoSchema = exports.MethodVideosSectionSchema = void 0;
const z = __importStar(require("zod"));
const typing_utils_1 = require("../typing_utils");
// CONSTANTS
const methodVideosSections = ["videos", "learn_more_effectively"];
// SCHEMAS
exports.MethodVideosSectionSchema = z.union(typing_utils_1.mapArrayToLiteralTuple(methodVideosSections));
exports.TheMethodVideoSchema = z.object({
    duration: z.number(),
    first_view: z.string().optional(),
    id: z.string(),
    section: exports.MethodVideosSectionSchema.optional(),
    title: z.string(),
    transcript: z.string().optional(),
    url: z.string(),
});
exports.TheMethodVideoWatchedEntrySchema = z.object({
    first_view: z.string(),
    id: z.string(),
});
exports.TheMethodVideoWatchedEntrySchemaList = exports.TheMethodVideoWatchedEntrySchema.array();
// TYPE GUARDS
const isTheMethodVideo = (x) => exports.TheMethodVideoSchema.safeParse(x).success;
exports.isTheMethodVideo = isTheMethodVideo;
//# sourceMappingURL=the_method_videos_types.js.map